import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'

export default class DeviceEditForm extends React.PureComponent<AppFormPageProps> {
    state = {}
    
	render() {
		let {formData,mode,id} = this.props;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='pos_program' loadingData={false} mode={mode} keyValue={id} formData={formData} afterSave={()=>{this.props.afterSave && this.props.afterSave()}}>
                    <AppForm.Section labelWidth={110}>
						<AppForm.Item field='version' itemType={AppFormItemEnum.input} label="版本" req unRepeat />
                        <AppForm.Item field='file_name' itemType={AppFormItemEnum.input} label="文件名称" req  />
                        <AppForm.Item field='force_update' dataType='number' itemType={AppFormItemEnum.radio} label="是否强制更新"  />
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/device/ProgramEditForm.tsx